import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'app-app-download-overlay',
	templateUrl: './app-download-overlay.component.html',
	styleUrls: ['./app-download-overlay.component.scss']
})
export class AppDownloadOverlayComponent implements OnInit {
	@Input() data: any = {};
	@Input() employerPath: string = '';
	@Input() eapUrl: string = '';
	@Input() groupCode: string = '';
	@Input() groupCodeLabel: string = '';
	@Output() dismissed = new EventEmitter<void>();

	public visible: boolean = false;

	private get storageKey(): string {
		return 'om-app-overlay-seen-' + this.employerPath;
	}

	ngOnInit(): void {
		// TODO: Uncomment this block to restore "show only once" behavior
		// if (localStorage.getItem(this.storageKey)) {
		// 	this.dismissed.emit();
		// } else {
		// 	this.visible = true;
		// }
		this.visible = true; // TODO: Remove this line when restoring "show only once" behavior
	}

	dismiss(): void {
		this.visible = false;
		// TODO: Uncomment this line to restore "show only once" behavior
		// localStorage.setItem(this.storageKey, 'true');
		this.dismissed.emit();
	}
}
